import styled from 'styled-components';

export const StyleFooter = styled.div`
  text-align: center;
  font-weight: 400;
  background: none;

  .ant-layout-footer {
    color: #777777;
    font-size: 12px;
  }
`;
